var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-result',{attrs:{"icon":"warning","title":"404提示","sub-title":"你找的页面走丢了~"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push({ path: '/' })}}},[_vm._v("回到首页")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }